import structuredClone from '@ungap/structured-clone';

// deep copy needed for nested objects to allow array manipulation in state
const deepCopy = (obj: any) => structuredClone(obj);

export default deepCopy;
